import React, { useMemo } from 'react'
import useOfferList from 'hooks/Offers/useOfferList'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import styled from 'styled-components'
import TextLink from 'components/Luxkit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import {
  OfferListEventsProvider,
} from 'components/OfferList/OfferListEventsContext'
import Group from 'components/utils/Group'
import { EmptyObject } from 'lib/object/objectUtils'

import HeroOfferCarouselLookingForSomethingElse from 'home/components/LookingForSomethingElse/HeroOfferCarouselLookingForSomethingElse'
import PaletteSheet from 'components/Luxkit/PaletteSheet'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { getListName } from 'analytics/enhanced-ecommerce'
import getOfferListKey from 'lib/offer/offerListKey'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from 'constants/search'
import qs from 'qs'

const ExclusiveOfferContainer = styled(PaletteSheet)`
  padding: ${rem(64)} 0 ${rem(32)};
  background-color: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    padding: ${rem(96)} 0  ${rem(40)};
  }
`

const TopExclusiveHeaderGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-areas:
    "title link";
  grid-template-columns: 1fr max-content;
  grid-gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    grid-gap: ${rem(16)};
  }

  > .title-area {
    grid-area: title;
  }

  > .link-area {
    grid-area: link;
  }
`

interface Props {
  filters?: App.OfferListFilters;
  random?: boolean;
}

function HotelExclusiveOfferCarousel(props: Props) {
  const {
    filters = EmptyObject,
    random,
  } = props
  const offerList = useOfferList(filters, { randomize: random })

  const tracking = useOfferListTracking(getListName('OfferList', 'Hotels', 'Hero Carousel'), { key: getOfferListKey(filters) })

  const mapViewURL = useMemo(() => {
    const query = qs.stringify(
      {
        adults: 2,
        children: 'none',
        destinationId: ANYWHERE_PLACE_ID,
        destinationName: ANYWHERE_NAME,
        holidayTypes: 'Limited Time LUX Exclusive',
      },
    )
    return `/search?${query}`
  }, [])

  return (
    <ExclusiveOfferContainer paletteType="inverse">
      <Group direction="vertical" gap={24} tabletGap={32}>
        <LayoutContainer>
          <TopExclusiveHeaderGrid>
            <Heading className="title-area" variant="heading2" align="start" >Today's top <i>exclusive</i> offers</Heading>
            <TextLink className="link-area" size="medium" to={mapViewURL}>View all</TextLink>
          </TopExclusiveHeaderGrid>
        </LayoutContainer>
        <OfferListEventsProvider tracking={tracking}>
          <OfferListCarousel
            tileStyle="card-medium"
            overrideOfferList={offerList}
            limit={15}
          >
            <HeroOfferCarouselLookingForSomethingElse
              link={mapViewURL}
              offerType="hotels"
            />
          </OfferListCarousel>
        </OfferListEventsProvider>
      </Group>
    </ExclusiveOfferContainer>
  )
}

export default HotelExclusiveOfferCarousel
